module.exports = __webpack_public_path__ + "img/证书5.d5c7ad95.jpg";